'use strict'

var config, service, documenti;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  documenti = config.VUE_APP_MOL_S_DOCUMENTS
}

async function getModello(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${documenti}/modello/${tipo}`)
  return await response.json()
}

async function getDocumento(id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/${encodeURIComponent(id)}`)
    return await response.json()
  } catch (error) {
    return null
  }
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/cicleSync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ multiplo })
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/mode`)
    const result = await response.json()
    if (result.status === 404) {
      return defaultRunMode()
    }
    return result
  } catch {
    return defaultRunMode()
  }
}

function defaultRunMode() {
  return {
    modulo: 'DOCUMENTI',
    locale: '---',
    remote: '---',
    versione: '---',
    health: '---'
  }
}

/* async function creaDocumentiMultipli(magazzino, parametri, documenti) {
  try {
    const data = {
      magazzino,
      parametri,
      documenti
    }
    const response = await fetch(`${service}/${documenti}/multipli`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return response.json()
  } catch (error) {
    console.log(error)
    // winston.error(`creaDocumentiMultipli: ${error}`);
  }
  return {}
} */

async function getFilteredDocumentHeaders(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/testate/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getFilteredLavorazioni(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/lavorazioni/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getFattureElettronichePassive(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/passive/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getCustomDocumentHeaders(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/testate/custom`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getFilteredDocumentCustomers(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/testate/clienti/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

// non ancora usata, non è completa
async function getFilteredDocuments(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${documenti}/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function creaDocumento(documento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/singolo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(documento)
    })
    return response.json();
  } catch (error) {
    console.log(error)
    // errorService.onError('creaDocumento', error);
  }
  return {}
}

async function aggiornaDocumento(documento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/${encodeURIComponent(documento._id)}/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(documento)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    // errorService.onError(error, 'aggiornaDocumento')
  }
}

async function cancellaDocumento(documentoId) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/${encodeURIComponent(documentoId)}/delete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    // errorService.onError(error, 'cancellaDocumento')
  }
}

async function creaFattureDefinitive(idsDocumenti) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      idsDocumenti
    }
    const response = await fetch(`${service}/${documenti}/definitive`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return response.json();
  } catch (error) {
    console.log(error)
  }
  return {}
}

async function trasformaDocumento(sorgente, tipoDestinazione, statoSorgente) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      idSorgente: sorgente._id,
      tipoDestinazione,
      statoSorgente
    }
    const response = await fetch(`${service}/${documenti}/trasforma`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return response.json();
  } catch (error) {
    console.log(error)
  }
  return {}
}

async function getDocumentiByIds(ids) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${documenti}/ids`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ids)
    })
    const result = await response.json()
    return result.rows.filter(x => !x.error && !x.value.deleted).map(x => x.doc)
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getProdottiDistinta(prodotto) {
  let elencoProdotti = []
  const codiceDistinta = _.get(prodotto, 'bom.gestione.distinta.codice')
  if (codiceDistinta) {
    const documento = await getDocumento(codiceDistinta) 
    const distinta = documento.distinta || {}
    const elenco = elaboraItem(distinta, 1, 0)
    elencoProdotti = elenco.filter(x => ['prodotto', 'multiselect'].includes(x.tipo) && !x.semilavorato && x.livello > 0).map(x => { return { codice: x.codice, descrizione: x.descrizione }} )
  }
  return elencoProdotti
}

function elaboraItem(item, qta = 1, livello) {
  if (!item) return []
  let elenco = []
  if (item.items) {
    elenco.push({ livello: livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: true, unitaMisura: item.unitaMisura })
    for (let i of item.items) {
      const totQta = qta * item.quantita
      elenco = elenco.concat(elaboraItem(i, totQta, livello + 1))
    }
  } else {
    let valori = item.valori || []
    elenco.push({ livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: false, unitaMisura: item.unitaMisura, valori: valori })
  }
  return elenco
}

async function aggiornaFlagClienteEsistente(partitaIva) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      partitaIva
    }
    const response = await fetch(`${service}/${documenti}/fein/esistente`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    // errorService.onError(error, 'aggiornaDocumento')
  }
}

async function inviaFtp(dati, config) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      dati,
      config
    }
    const response = await fetch(`${service}/${documenti}/export/ftp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function salvaFileLocale(dati, config) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      dati,
      config
    }
    const response = await fetch(`${service}/${documenti}/export/file`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}


async function leggeFtp(config) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      config
    }

    const response = await fetch(`${service}/${documenti}/import/ftp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    return await response.json()
  } catch (error) {
    console.log(error)
  }
}



async function leggeFileLocale(config) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      config
    }

    const response = await fetch(`${service}/${documenti}/import/file`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}



async function eliminaFileLocale(file) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      file
    }
    const response = await fetch(`${service}/${documenti}/import/file`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}



async function eliminaFileFtp(config) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      config
    }
    const response = await fetch(`${service}/${documenti}/import/ftp`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function statisticaRiepilogoFatture(filtro, payload) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      payload
    }
    const response = await fetch(`${service}/${documenti}/statistica/riepilogo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}


async function estraeRigheFatture(filtro) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro
    }
    const response = await fetch(`${service}/${documenti}/gestione/ingresso/righe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function ddtDaProforma(idProforma) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      idProforma
    }
    const response = await fetch(`${service}/${documenti}/ddtDaProforma`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}


export default {
  getDocumento,
  getModello,
  cicleSync,
  getRunMode,
  creaDocumento,
  aggiornaDocumento,
  // creaDocumentiMultipli,
  getFilteredDocumentHeaders,
  getFilteredLavorazioni,
  getFattureElettronichePassive,
  getCustomDocumentHeaders,
  getFilteredDocumentCustomers,
  getFilteredDocuments,
  cancellaDocumento,
  creaFattureDefinitive,
  trasformaDocumento,
  getDocumentiByIds,
  getProdottiDistinta,
  aggiornaFlagClienteEsistente,
  inviaFtp,
  salvaFileLocale,
  statisticaRiepilogoFatture,
  leggeFtp,
  leggeFileLocale,
  eliminaFileLocale,
  eliminaFileFtp,
  estraeRigheFatture,
  ddtDaProforma
}
